import React from 'react';

import { Button, Layout } from 'antd';
import { Header } from 'antd/es/layout/layout';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import axios from 'lib/axios.factory';

import { Actions, trackOnboarding } from '../../../actions';
import onBoardingImage from '../../../images/onboarding/onboarding.svg';
import { updateAccount } from '../../../lib/api';
import { ImageOnRightSide } from '../../common/ImageOnRightSide';
import { MutedText } from '../../common/MutedText';

const Style = styled.div`
  height: 100%;

  .onboarding {
    width: 100%;
  }
  .onboarding h1 {
    font-size: 30px;
  }
  .onboarding img {
    height: 133px;
  }

  .ant-btn-background-ghost {
    background-color: white;
    border-color: #1a21ff;
    color: #1a21ff;
  }
  .right-container {
    display: block !important;
  }
`;

export function WelcomeAfterSignup(props) {
  return (
    <Style>
      <Header
        style={{
          backgroundColor: 'white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          height: '120px',
        }}
        theme="light"
      >
        <div>
          <h1 style={{ marginBottom: 5, fontSize: 30, fontWeight: 700 }}>Welcome to PixelMe!</h1>
          <h3>Select a user type below to get started</h3>
        </div>
      </Header>
      <ImageOnRightSide theme="half" image={<Right account={props.account} />}>
        <Left account={props.account} />
      </ImageOnRightSide>
    </Style>
  );
}

function Left(props) {
  const history = useHistory();

  return (
    <div className="onboarding">
      <LeftSideImage />
      <h1>Amazon Seller</h1>
      <div className="onboarding__container_button">
        <Button
          block
          size="large"
          type="primary"
          onClick={async () => {
            await updateAccount(
              localStorage,
              axios,
              { accountId: props.account.id },
              {
                type: 'SELLER',
              },
            );
            history.push(`/${props.account.id}/adsprovider`);
          }}
        >
          Create Your First Amazon Attribution Campaign
        </Button>
      </div>
      <MutedText style={{ marginTop: '10px' }}>
        You can also create custom attribution links.
        <br />
        Click above to get started
      </MutedText>
    </div>
  );
}

function Right() {
  const history = useHistory();
  const dispatch = useDispatch();

  const { accountId, link, domain, pixel, selectedCampaignId, selectedSubCampaignId } = useSelector((state) => ({
    selectedCampaignId: state.campaigns.selectedCampaignId,
    selectedSubCampaignId: state.campaigns.selectedSubCampaignId,
    accountId: state.accounts.selected,
    link: state.accounts.usage.shortens > 0,
    domain: state.accounts.usage.brandedDomains > 0,
    pixel: state.accounts.usage.pixels > 0,
  }));

  const toogleComposer = () => {
    dispatch(
      Actions.front.audienceBuilder.redirect.create.show.request({
        selectedCampaignId,
        selectedSubCampaignId,
      }),
    );
  };

  const onClickonBoarding = (step) => {
    switch (step) {
      case 'link':
        toogleComposer();
        history.push(`/${accountId}/ab`);
        dispatch(trackOnboarding({ action: 'link' }));
        break;
      case 'pixel':
        history.push(`/${accountId}/ab/settings/pixels`);
        dispatch(trackOnboarding({ action: 'pixel' }));
        break;
      case 'domain':
        history.push(`/${accountId}/ab/settings/domains`);
        dispatch(trackOnboarding({ action: 'domain' }));
        break;
      default:
        break;
    }
  };

  return (
    <div className="onboarding">
      <img alt="onboardingimg" src={onBoardingImage} />
      <h1>Not An Amazon Seller</h1>
      <div className="onboarding__container_button">
        <div onClick={() => onClickonBoarding('link')}>
          <Button disabled={link} size="large" ghost={true} style={{ marginRight: '1rem' }}>
            Create your first link
          </Button>
        </div>
        <div onClick={() => onClickonBoarding('pixel')}>
          <Button disabled={pixel} ghost={true} size="large">
            Add your first retargeting pixel
          </Button>
        </div>
        <div onClick={() => onClickonBoarding('domain')}>
          <Button ghost={true} disabled={domain} size="large" style={{ marginLeft: '1rem' }}>
            Add a branded domain
          </Button>
        </div>
      </div>
      <MutedText style={{ marginTop: '10px' }}>
        Brand, track & share your own branded short URLs
        <br /> and retarget anyone who clicked on your links!
      </MutedText>
    </div>
  );
}

function LeftSideImage() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="239" height="138" fill="none" viewBox="0 0 239 138">
      <g clipPath="url(#clip0_3064_57039)">
        <path
          fill="#F2F2F2"
          d="M22.122 107.799a.926.926 0 01-.67-1.606l.063-.252-.026-.061a2.485 2.485 0 00-3.671-1.097 2.488 2.488 0 00-.912 1.114c-.75 1.808-1.704 3.62-1.939 5.532a7.373 7.373 0 00.13 2.532 29.559 29.559 0 01-2.681-12.26 28.534 28.534 0 01.582-5.756 29.884 29.884 0 015.911-12.656 7.941 7.941 0 003.3-3.429 6.07 6.07 0 00.55-1.656 7.55 7.55 0 01-.484.044l-.153.008-.019.001a.915.915 0 01-.952-1.016.919.919 0 01.2-.48l.207-.256c.106-.132.214-.261.32-.393a.495.495 0 00.033-.04l.364-.448a2.652 2.652 0 00-.87-.842c-1.213-.712-2.888-.219-3.765.881-.88 1.1-1.045 2.643-.74 4.018.3 1.169.797 2.279 1.47 3.281-.066.084-.135.166-.2.25a30.064 30.064 0 00-3.132 4.97 12.515 12.515 0 00-.745-5.803c-.713-1.722-2.048-3.173-3.225-4.662-1.413-1.788-4.31-1.008-4.56 1.26l-.007.065c.175.099.346.204.513.315a1.257 1.257 0 01-.506 2.287l-.025.004c.062.631.172 1.257.329 1.87a12.887 12.887 0 006.401 8.072c.103.053.203.106.306.156a30.718 30.718 0 00-1.649 7.77 29.141 29.141 0 00.022 4.699l-.008-.056a7.688 7.688 0 00-2.62-4.44c-2.017-1.658-4.866-2.27-7.04-3.603a1.439 1.439 0 00-2.198 1.462 8.43 8.43 0 011.458.77 1.256 1.256 0 01.161 1.963 1.253 1.253 0 01-.667.326l-.025.003-.053.008a12.513 12.513 0 002.299 3.606 12.868 12.868 0 009.332 4.102h.003a30.695 30.695 0 002.057 6.014h7.347c.026-.082.05-.166.074-.248a8.345 8.345 0 01-2.034-.121c.546-.67 1.09-1.345 1.636-2.015a.517.517 0 00.034-.04c.277-.343.556-.683.832-1.026.015-1.052-.105-2.1-.358-3.121z"
        ></path>
        <path
          fill="#CCC"
          d="M112.606 114.469a.278.278 0 01-.023.117.304.304 0 01-.281.189H.326a.306.306 0 010-.611h111.976a.308.308 0 01.215.089.296.296 0 01.089.216z"
        ></path>
        <path
          fill="#A0616A"
          d="M52.843 74.207a1.878 1.878 0 011.28 1.903 1.884 1.884 0 01-.225.784l2.695 3.35-1.632 2.137-3.74-4.784a1.893 1.893 0 011.623-3.39z"
        ></path>
        <path
          fill="#2F2E41"
          d="M54.049 83.332l-1.523-3.793 2.816-2.004 1.317 2.363 1.922 1.314 2.553 2.271c.692-.57 6.003-4.832 7.702-3.02a2.01 2.01 0 01.594 1.572c-.106 1.38-1.566 2.538-1.622 2.58l-3.224 3.033c-.12.205-1.387 2.318-2.835 2.685a1.543 1.543 0 01-1.23-.181c-3.297-2.027-5.404-4.022-6.178-5.833a4.18 4.18 0 01-.292-.987z"
        ></path>
        <path fill="#A0616A" d="M52.453 132.981l-2.48.116-1.627-9.525 3.66-.172.447 9.581z"></path>
        <path
          fill="#2F2E41"
          d="M53.782 137.645l-1.76.082-.391-1.649-.727 1.702-4.667.218a1.049 1.049 0 01-1.057-1.347c.064-.215.194-.404.372-.54l3.606-2.753-.078-1.682 3.93.051.772 5.918z"
        ></path>
        <path fill="#A0616A" d="M26.563 112.528l-.903-2.316 8.488-4.593 4.289 2.7-11.874 4.209z"></path>
        <path
          fill="#2F2E41"
          d="M22.577 115.283l-.641-1.644 1.434-.899-1.842-.145-1.7-4.359a1.056 1.056 0 01.322-1.205 1.05 1.05 0 011.244-.05l3.758 2.542 1.566-.613 1.21 3.746-5.351 2.627zM75.329 105.635s-1.03 6.585-5.898 7.073c-4.868.488-9.356-1.709-9.356-1.709l-13.63-4.205s-14.5 4.126-16.933 4.776c0 0-1.68-3.817-1.623-4.064.518-2.268 1.192-.734 1.192-.734l15.416-6.827s2.434-.65 6.653 1.138c4.22 1.788 15.522 6.098 15.522 6.098l8.657-1.546z"
        ></path>
        <path
          fill="#2F2E41"
          d="M75.273 105.23s.812 7.89-3.93 9.095c-4.508 1.146-10.726-.029-10.726-.029l-7.413-.776s-.325 9.541-.325 14.255a35.6 35.6 0 01-4.543.325c-.325 0-.347-.17-.347-.17l-.628-16.49a5.153 5.153 0 013.219-5.094 5.132 5.132 0 012.096-.365c.35.014.717.038 1.101.075 4.56.438 10.222-.493 10.222-.493l11.274-.333z"
        ></path>
        <path
          fill="#2F2E41"
          d="M62.12 93.785s-1.926 11.662-.625 12.593c1.301.931 3.085.935 3.085.935l.415-6.439-2.876-7.089zM65.33 79.463l-2.574 2.45a7.604 7.604 0 00-1.493 9.038l1.23 2.35 2.837-13.838z"
        ></path>
        <path
          fill="#2E89E2"
          d="M65.906 79.875l-3.488 3.98a5.59 5.59 0 00-1.294 4.694l1.315 7.158.988 10.336s7.627 2.315 8.408-1.259c.78-3.575-5.93-24.909-5.93-24.909z"
        ></path>
        <path
          fill="#2F2E41"
          d="M63.917 102.662l-1.115-2.569-.946-6.698c-.052-.39 1.007-6.767 2.54-13.61l1.864-2.612 1.075-.987 3.062 2.01c1.104.585 3.52 8.225 2.033 13.63-.511 1.86.382 4.175.52 5.884l2.123 5.223.502 3.021-.077.029c-.076.03-1.304.196-6.318 1.033-4.155.693-1.88-2.719-5.263-4.354z"
        ></path>
        <path
          fill="#A0616A"
          d="M54.102 99.855a1.88 1.88 0 012.866-.315l3.933-1.728 1.631 2.14-5.59 2.361a1.894 1.894 0 01-1.248.495 1.895 1.895 0 01-1.9-1.644c-.06-.459.05-.925.309-1.309z"
        ></path>
        <path
          fill="#2F2E41"
          d="M63.209 101.082l-4.054.477-1.192-3.247 2.622-.653 1.77-1.514 2.857-1.873c-.367-.818-3.082-7.07-.891-8.236a2.004 2.004 0 011.67-.163c1.302.464 2.035 2.18 2.061 2.244l2.077 3.912c.166.17 1.869 1.949 1.843 3.445a1.552 1.552 0 01-.497 1.142c-2.817 2.655-5.291 4.169-7.238 4.442a4.11 4.11 0 01-1.028.024z"
        ></path>
        <path
          fill="#A0616A"
          d="M65.843 75.856c2.679-.322 4.585-2.807 4.257-5.55-.328-2.744-2.766-4.708-5.446-4.386-2.68.321-4.585 2.806-4.257 5.55.328 2.744 2.766 4.707 5.446 4.386z"
        ></path>
        <path
          fill="#2F2E41"
          d="M77.973 67.176c-.94-.865-1.485-2.096-2.275-3.11-.79-1.015-2.054-1.857-3.236-1.457-.815.276-1.372 1.092-1.6 1.955-.229.862-.181 1.778-.132 2.674-.199-1.83-1.613-3.458-3.339-3.843a4.203 4.203 0 00-4.495 2.098 2.543 2.543 0 00-3.367.332 2.845 2.845 0 00-.035 3.537 2.563 2.563 0 003.359.479l.427.308a1.684 1.684 0 001.14 1.83c.6.163 1.404.028 1.69.604.2.402-.026.884-.285 1.243-.259.359-.572.735-.555 1.186.027.68.78 1.07 1.429 1.136a3.994 3.994 0 003.891-2.204 1.34 1.34 0 01.046-.085 5.949 5.949 0 00.645-4.652c-.087-.306-.065-.544.141-.643.889-.43 3.566-.073 4.424.438.859.51 1.584 1.236 2.418 1.789.834.553 1.858.934 2.799.643a2.997 2.997 0 001.7-1.6 8.347 8.347 0 00.653-2.355 4.361 4.361 0 01-5.443-.303zM78.713 99.74l-.003-.004.003.009v-.005z"
        ></path>
        <path
          fill="#3F3D56"
          d="M46.927 76.373a10.739 10.739 0 01-6.18-.888 10.761 10.761 0 01-4.647-4.177 10.788 10.788 0 01.527-11.959 10.756 10.756 0 014.997-3.75A10.737 10.737 0 0153.23 58.45a10.781 10.781 0 012.512 9.84 10.78 10.78 0 01-4.87 6.647 10.742 10.742 0 01-3.945 1.436zm-3.183-20.79a10.236 10.236 0 00-5.363 2.573 10.277 10.277 0 00.855 15.84 10.232 10.232 0 0015.342-3.93 10.276 10.276 0 00-3.22-12.613 10.235 10.235 0 00-7.614-1.87zM84.715 35.535a10.739 10.739 0 01-6.18-.887 10.761 10.761 0 01-4.647-4.178 10.788 10.788 0 01.527-11.959 10.756 10.756 0 014.997-3.75 10.737 10.737 0 0111.606 2.852 10.78 10.78 0 012.512 9.84 10.78 10.78 0 01-4.87 6.646 10.742 10.742 0 01-3.945 1.436zm-3.183-20.79a10.236 10.236 0 00-5.363 2.573 10.276 10.276 0 00.855 15.84 10.232 10.232 0 0015.342-3.93 10.276 10.276 0 00-3.22-12.613 10.23 10.23 0 00-7.614-1.87zM128.297 59.941a10.74 10.74 0 01-6.181-.887 10.766 10.766 0 01-4.647-4.178 10.791 10.791 0 01.528-11.958 10.76 10.76 0 014.997-3.75 10.738 10.738 0 0111.606 2.85 10.779 10.779 0 012.512 9.84 10.788 10.788 0 01-4.871 6.648 10.746 10.746 0 01-3.944 1.435zm-3.183-20.79a10.236 10.236 0 00-5.363 2.573 10.272 10.272 0 00.855 15.84 10.229 10.229 0 0011.369.503 10.25 10.25 0 003.972-4.433 10.278 10.278 0 00.844-5.897 10.263 10.263 0 00-4.063-6.715 10.23 10.23 0 00-7.614-1.87zM179.962 21.424a10.738 10.738 0 01-6.181-.888 10.76 10.76 0 01-4.647-4.177 10.783 10.783 0 015.525-15.71 10.735 10.735 0 016.234-.337 10.756 10.756 0 015.372 3.19 10.786 10.786 0 01-2.359 16.486 10.745 10.745 0 01-3.944 1.436zM176.779.634a10.254 10.254 0 00-8.395 7.697 10.26 10.26 0 003.886 10.715 10.233 10.233 0 0015.342-3.93 10.264 10.264 0 00-3.22-12.612 10.227 10.227 0 00-7.613-1.87zM228.935 40.109a10.74 10.74 0 01-6.181-.887 10.765 10.765 0 01-6.193-10.237 10.774 10.774 0 017.071-9.65 10.738 10.738 0 0111.606 2.852 10.788 10.788 0 01.737 13.649 10.754 10.754 0 01-7.04 4.273zm-3.183-20.79a10.235 10.235 0 00-5.363 2.573 10.269 10.269 0 00.855 15.84 10.231 10.231 0 0015.342-3.93 10.277 10.277 0 00-3.22-12.612 10.23 10.23 0 00-7.614-1.87z"
        ></path>
        <path
          fill="#3F3D56"
          d="M88.713 21.038l1.227-.448s-.88 1.355-1.072 1.462c.02.256.06.51.117.761-.83 10.819-10.497 7.581-10.497 7.581 3.276-.425 3.35-1.812 3.35-1.812-1.942.013-2.512-1.171-2.512-1.171A.79.79 0 0080.3 27c-2.132-.217-2.16-2.263-2.16-2.263.406.209.858.309 1.314.292-.27-.244-2.547-2.256-1.566-3.626 0 0 1.806 2.317 5.562 1.974l.245-.09a2.014 2.014 0 01-.136-.55 2.697 2.697 0 012.25-3.07c1.772-.272 2.307.684 2.307.684l1.149-.956c-.025.004.042 1.291-.552 1.642zM128.755 43.58a2.717 2.717 0 013.083 2.266l.819 5.353a2.717 2.717 0 01-2.262 3.088l-5.345.82a2.717 2.717 0 01-3.082-2.266l-.819-5.353a2.717 2.717 0 012.262-3.087l5.344-.821zm-.163-1.07l-5.345.82a3.797 3.797 0 00-3.167 4.322l.819 5.354a3.805 3.805 0 001.504 2.478 3.792 3.792 0 002.811.695l5.345-.821a3.806 3.806 0 003.167-4.322l-.82-5.354a3.798 3.798 0 00-4.314-3.173z"
        ></path>
        <path
          fill="#3F3D56"
          d="M129.967 46.133a.81.81 0 01-.773-1.281.81.81 0 11.776 1.28l-.003.002zM126.575 47.204a2.16 2.16 0 012.178 1.018 2.174 2.174 0 01-.107 2.405 2.16 2.16 0 01-3.881-.953 2.184 2.184 0 01.394-1.61 2.163 2.163 0 011.416-.86zm-.164-1.07a3.246 3.246 0 00-2.557 4.321 3.25 3.25 0 002.906 2.137 3.243 3.243 0 003.082-1.872 3.253 3.253 0 00-1.019-3.994 3.24 3.24 0 00-2.412-.593zM226.621 22.507a7.05 7.05 0 00-4.156 2.238 7.075 7.075 0 00-.482 8.895 7.05 7.05 0 003.889 2.676 6.212 6.212 0 01-.124-1.62l.313-3.945a2.716 2.716 0 01-.393-1.069c-.158-1.035.321-1.9 1.068-2.014.635-.098 1.013.332 1.1.903.098.639-.164 1.655-.237 2.572a1.1 1.1 0 00.358.919 1.087 1.087 0 00.95.256c1.319-.203 1.949-2.039 1.641-4.052-.235-1.53-1.44-2.517-3.31-2.23-2.113.325-3.191 2.108-2.921 3.873.056.5.294.963.67 1.297a.347.347 0 01.16.375c-.015.133-.043.453-.058.583a.238.238 0 01-.102.197.24.24 0 01-.22.031c-1.035-.25-1.652-1.246-1.836-2.449-.304-1.983 1.003-4.618 4.314-5.126 2.661-.41 4.709 1.251 5.025 3.321.42 2.74-.789 5.02-3.029 5.363-.754.116-1.522-.184-1.836-.608 0 0-.158 1.67-.198 1.996a5.836 5.836 0 01-.471 1.604 7.04 7.04 0 005.612-1.699 7.07 7.07 0 001.729-8.292 7.063 7.063 0 00-4.462-3.807 7.042 7.042 0 00-2.994-.188zM183.859 5.636L174.47 4.25a.926.926 0 00-1.089.732l-.001.004-1.387 9.426a1 1 0 00.819 1.107l9.387 1.386a.95.95 0 001.045-.833l1.386-9.426a.871.871 0 00-.771-1.01zm-8.245 8.38l-1.611-.238.738-5.02 1.612.239-.739 5.02zm.101-5.893l-.012-.002a.886.886 0 01-.392-1.59.884.884 0 011.237.183.89.89 0 01-.178 1.24.884.884 0 01-.655.169zm5.79 6.763l-1.612-.238.404-2.745c.097-.657-.072-1.141-.655-1.227a.887.887 0 00-.914.474 1.08 1.08 0 00-.114.388l-.421 2.859-1.612-.238.739-5.02 1.612.238-.103.699a1.647 1.647 0 011.573-.602c1.058.157 1.756.973 1.534 2.48l-.431 2.932z"
        ></path>
        <path
          fill="#3F3D56"
          fillRule="evenodd"
          d="M52.253 64.698a7.047 7.047 0 00-1.672-3.584 7.029 7.029 0 00-7.287-2.096 7.03 7.03 0 00-3.315 2.15 7.047 7.047 0 00-1.074 7.517 7.023 7.023 0 006.365 4.124l-.744-4.864-1.765.272-.309-2.013 1.765-.271-.234-1.534c-.267-1.745.623-2.868 2.21-3.112.522-.073 1.05-.107 1.577-.103l.262 1.713-.877.135c-.863.132-1.05.71-.966 1.262l.2 1.305 1.927-.296v2.06l-1.619.25.745 4.864a7.034 7.034 0 003.838-3 7.054 7.054 0 00.973-4.779z"
          clipRule="evenodd"
        ></path>
        <path fill="#FFB6B6" d="M181.931 109.641l2.572.676 3.828-9.614-3.795-.998-2.605 9.936z"></path>
        <path
          fill="#2F2E41"
          d="M181.136 112.305l7.908 2.08.026-.1a3.19 3.19 0 00-2.269-3.893l-1.157-1.478-2.983.389-.69-.182-.835 3.184z"
        ></path>
        <path fill="#FFB6B6" d="M195.114 111.568h2.659l1.265-10.273h-3.924v10.273z"></path>
        <path
          fill="#2F2E41"
          d="M195.02 114.346h8.176v-.103a3.187 3.187 0 00-3.182-3.188l-1.494-1.135-2.786 1.135h-.714v3.291zM188.464 62.41c-.642.804-.321 3.539-.321 3.539s-1.124 8.846-.642 9.65c.481.804-.322 1.447-.803 2.573-.482 1.126-.964 3.86-.964 3.86-2.729 2.252-2.569 12.546-2.569 12.546l-.963 9.167c.321.965 4.817 1.126 5.459.965.642-.161 6.904-22.839 6.904-22.839s-.321 21.874-.321 22.839c0 .965 4.336.483 5.299.483.963 0 7.065-39.405 7.065-39.405v-2.252l-.803-1.126s-16.699-.804-17.341 0z"
        ></path>
        <path
          fill="#FFB6B6"
          d="M195.529 32.976a4.982 4.982 0 004.978-4.986 4.982 4.982 0 00-4.978-4.986 4.981 4.981 0 00-4.977 4.986 4.981 4.981 0 004.977 4.986z"
        ></path>
        <path
          fill="#3F3D56"
          d="M188.842 65.966l-.027-.038c-1.45-2.033.73-6.92 1.059-7.628a1.779 1.779 0 01-1.215-1.9l.142-1.206.148-1.185-1.059-1.06-.003-.027-.609-5.34-.886-3.547a7.796 7.796 0 012.206-7.547l2.048-.326 2.489-2.402h4.013l1.376 1.317c2.706 2.221 3.348 1.256 6.399 5.438l-2.185 5.764 1.221 8.503.001 1.539.636.707a2.198 2.198 0 01.522 1.906l-.084.419a2.199 2.199 0 011.284 1.563l.224 1.044c.191.252 1.452 1.937 1.452 2.398 0 .069-.051.136-.16.21-.86.583-5.611 1.771-7.713.928-2.24-.896-11.143.45-11.233.463l-.046.007z"
        ></path>
        <path
          fill="#FFB6B6"
          d="M186.313 45.741l4.138-.811c1.531 2.29 2.353 8.55 2.353 8.55l4.575 9.506a1.86 1.86 0 01.895 1.649 1.865 1.865 0 01-2.862 1.518 1.868 1.868 0 01-.859-1.668l-5.968-11.262-2.272-7.482z"
        ></path>
        <path
          fill="#3F3D56"
          d="M186.29 46.724l-.118-6.162 1.948-2.61a3.42 3.42 0 013.37-1.306 3.418 3.418 0 012.732 3.785c-.33 2.61-1.081 5.875-2.779 6.613l-.017.008 1.76 6.165-6.526.913-.37-7.406z"
        ></path>
        <path
          fill="#FFB6B6"
          d="M212.993 41.516s-6.175-1.268-8.836-.567l-.587 4.183 7.533.67 12.858-2.341a1.857 1.857 0 001.849-.28c.257-.206.454-.476.572-.783.119-.307.154-.64.102-.965a1.857 1.857 0 00-1.182-1.452 1.86 1.86 0 00-1.845.31l-10.464 1.225z"
        ></path>
        <path
          fill="#3F3D56"
          d="M205.515 46.112l-6.115-.675-2.333-2.27a3.438 3.438 0 01-.861-3.516 3.424 3.424 0 011.612-1.924 3.41 3.41 0 012.488-.304c2.54.663 5.082.044 5.595 1.826l.916-.3 6.013 1.147.065 6.6-7.38-.584z"
        ></path>
        <path
          fill="#2F2E41"
          d="M189.883 24.715c.559-.867 1.608-1.444 2.625-1.282a3.584 3.584 0 016.005-2.094 1.115 1.115 0 011.09-.109c.35.16.654.404.885.712a5.165 5.165 0 01.722 5.256c.124-.453-.329-.878-.786-.98-.457-.102-.937-.006-1.401-.072-.595-.084-1.129-.43-1.724-.508a3.92 3.92 0 00-1.492.192c-.48.16-.986.228-1.491.201-.501-.06-1.147 1.843-1.138 3.183.001.254-.051.58-.299.634-.305.066-.482-.356-.772-.47a.536.536 0 00-.659.35.888.888 0 00.167.786c.179.214.391.399.628.545l-.12.1a.709.709 0 01-.898.112 1.945 1.945 0 01-.645-.736 8.655 8.655 0 01-1.183-2.84 4.143 4.143 0 01.486-2.98z"
        ></path>
        <path
          fill="#F0F0F0"
          d="M231.643 110.29l-1.975-3.178-.394 1.816a63.17 63.17 0 00-.202.962 29.212 29.212 0 00-1.741-1.349 3516.169 3516.169 0 01-5.375-3.914l.56 3.257c.346 2.006.707 4.053 1.562 5.887.095.208.198.413.308.613h8.332c.067-.186.114-.378.139-.574a.255.255 0 00.002-.039c.131-1.244-.556-2.416-1.216-3.481z"
        ></path>
        <path
          fill="#CACACA"
          d="M238.695 114.697l-70.61.079a.304.304 0 01-.216-.09.304.304 0 01.216-.521l70.61-.079a.306.306 0 110 .611z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_3064_57039">
          <path fill="#fff" d="M0 0H239V138H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}
